import './RadioButtonGroup.scss';
import React, { useRef } from 'react';
import SelectOption from '../../../infrastructure/types/SelectOption';
import { generateKey } from '../../../infrastructure/helpers/react/commonHelper';

interface RadioButtonGroupProps {
    options: SelectOption[];
    value: string;
    name: string;
    labelClassName?: string,
    onChange: (value: string, scrollLeft?: number) => void;
    isDisabled?: (value: string) => boolean;
    className?: string;
    scrollLeft?: number;
}

class RadioButtonGroup extends React.Component<RadioButtonGroupProps> {

    private ref = React.createRef<HTMLDivElement>();

    constructor(props: RadioButtonGroupProps) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.getRadioButton = this.getRadioButton.bind(this);
    }

    componentDidUpdate(prevProps: RadioButtonGroupProps) {

        if (this.ref.current && this.props.scrollLeft && this.props.scrollLeft !== this.ref.current.scrollLeft) {
            this.ref.current.scrollLeft = this.props.scrollLeft;
        }
    }

    getRadioButton(option: SelectOption): JSX.Element {
        return (
            <label key={generateKey()} className={this.props.labelClassName || ''}>
                <input
                    key={generateKey()}
                    type="radio"
                    value={option.value}
                    checked={this.props.value === option.value}
                    onChange={this.onChange}
                    disabled={this.props.isDisabled ? this.props.isDisabled(option.value) : false} />
                {option.text}
            </label>
        );
    }

    onChange(e: React.ChangeEvent<HTMLInputElement>): void {

        let mainElement = e.target?.parentNode?.parentNode as HTMLElement;

        let scrollLeft = mainElement.scrollLeft || 0;

        this.props.onChange(e.target.value, scrollLeft);
    }

    render(): JSX.Element {
        return (
            <div ref={this.ref} className={`radio-button-group ${this.props.className || ''}`}>
                {this.props.options.map((option: SelectOption) => { return this.getRadioButton(option); })}
            </div>
        );
    }
}

export default RadioButtonGroup;
